<template>
<div>
  <img :src="isActive?activeSrc:src" alt="" class="svg-icon">
  <span>{{title}}</span>
</div>
  </template>
<script>
export default {
  name: "MenuItem",
  // functional: true,
  props: {
    icon: {
      type: String,
      default: "",
    },
    activeIcon: {
      type: String,
      default: "",
    },
    isActive:{
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    activeMenu: {
      type: String,
      // required: true,
    },
  },
  data(){
    return{
      src:'',
      activeSrc:'',
    }
  },
  created(){
    if (this.icon) {
    this.src=require(`@/assets/image/${this.icon}.png`),
    this.activeSrc=require(`@/assets/image/${this.activeIcon}.png`)
    }
  },
  render(h, context) {
    const { icon, title,activeIcon,isActive } = context.props;
    const vnodes = [];

    if (icon) {
      // vnodes.push(<svg-icon icon-class={icon} />);
      let src=require(`@/assets/image/${icon}.png`)
      let activeSrc=require(`@/assets/image/${activeIcon}.png`)
        // vnodes.push(<img src={isActive?activeSrc:src} alt="" class="svg-icon"></img>);
    }

    if (title) {
      // vnodes.push(<span>{title}</span>);
    }
    return vnodes;
  },
};
</script>
